export default __webpack_public_path__ + "static/media/cp_force.4b071cec.pdf";